import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IPayslip } from '../interface/IPayslip';

enum PayslipServiceEnum {
  created = "/created/"
}

export default class PayslipService extends ApiService {

  constructor(restClient: AxiosInstance) {
    super(restClient, "/payslip");
  }

  public getCreatedPayslip = async (): Promise<IPayslip[]> => await this.GET(PayslipServiceEnum.created);
}



// WEBPACK FOOTER //
// ./src/services/api/Payslip.service.ts